import React, { useState, useEffect } from 'react'
import { Table, IconButton, Icon, Panel, Button, Row, Col, Checkbox, Input, ControlLabel } from 'rsuite'
import { startLoading, doneLoading } from '../../../utils/loading'
import { Controller, useForm } from 'react-hook-form'
import AppContext from '../../../context/AppContext'
import { isEmpty } from 'lodash-es'
import { sessionGetItemStr } from '../../../utils/sessionHelpers'
import notification from '../../../utils/notification'
import OverlayLoader from '../../../components/OverlayLoader/OverlayLoader'
import './styles.less'
import { budgetFormat } from '../../../utils/formatterUtil'
import { DEFAULT_ERR_MSG, SAVE_SUCCESS_MSG } from '../../../constants/msgText'
import { getAssetMigration, saveAssetMigrationRequest } from '../../../redux/actions/assetMigration'
import ConfirmWidget from '../../confirm/ConfirmWidget'
import { requiredFiled } from '../../../utils/ValidatorUtils'

export default function AssetMigrationTable({ schema, loading }) {
  const { register, handleSubmit, errors, control, getValues, setValue, clearErrors } = useForm()
  const { theme } = React.useContext(AppContext)
  const { Column, HeaderCell, Cell } = Table
  const [tableData, setTableData] = useState([])
  const [formSchema, setFormSchema] = useState(schema)
  const [isLoading, setIsLoading] = useState(false)
  const [indeterminate, setIndeterminate] = useState(false)
  const [checkedKeys, setCheckedKeys] = useState([])
  const [countSelected, setCountSelected] = useState(0)
  const [searchProjectCode, setSearchProjectCode] = useState('')
  const [toProjectCode, setToProjectCode] = useState(null)

  const [isShowConfirm, setIsShowConfirm] = useState(false)

  const projectCode = sessionGetItemStr('projectCode')
  const fs = localStorage.getItem('fontSize')

  useEffect(() => {
    setTableData(schema.values)
  }, [schema.values])

  const handleSearchMigrationAsset = async (projectCode) => {
    console.log('avsdv')
    setIsLoading(true)
    startLoading()
    try {
      const { model } = await getAssetMigration(projectCode)
      setTableData(model.form.values)
      setCheckedKeys([])
      setCountSelected(0)
      handleCheckAll(null, false)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        notification.open('error', {
          title: e.response.data.errors?.message || DEFAULT_ERR_MSG,
          duration: 5000,
        })
      } else {
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
          duration: 5000,
        })
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleSaveMigrationAsset = async (request) => {
    setIsLoading(true)
    startLoading()

    try {
      let response = await saveAssetMigrationRequest(request)

      if (response.success) {
        setTableData([])
        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
          duration: 5000,
        })
      } else {
        notification.open('error', {
          title: response.message || DEFAULT_ERR_MSG,
          duration: 5000,
        })
      }
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        console.log(e?.response?.data)
        notification.open('error', {
          title: e.response.data.errorMessage || DEFAULT_ERR_MSG,
          duration: 5000,
        })
      } else {
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
          duration: 5000,
        })
      }
    }
    setIsShowConfirm(false)
    doneLoading()
    setIsLoading(false)
  }

  const onSubmit = () => {
    // var data = tableData.map((item) => {
    //   if (checkedKeys.includes(item.assetCode)) {
    //     item.isChecked = true
    //     return item
    //   }
    // })

    var data = tableData.filter((item) => checkedKeys.includes(item.assetCode))

    if (data.length == 0) {
      notification.open('error', {
        title: 'กรุณาเลือกอย่างน้อย 1 รายการ',
        duration: 5000,
      })

      setIsShowConfirm(false)
      return
    }

    if (toProjectCode == null || isEmpty(toProjectCode)) {
      notification.open('error', {
        title: 'กรุณาเลือกกรอกรหัสโครงการปลายทาง',
        duration: 5000,
      })

      setIsShowConfirm(false)
      return
    }

    data = data.map((item) => {
      item.currentProjectCode = toProjectCode
      return item
    })

    handleSaveMigrationAsset(data)
  }

  const handleCheckAll = (value, checked) => {
    const checkedKeys = checked ? tableData.map((item) => item.assetCode) : []
    setCheckedKeys(checkedKeys)
    setCountSelected(checkedKeys.length)
  }

  const handleCheck = (value, checked) => {
    const nextCheckedKeys = checked
      ? [...checkedKeys, value]
      : checkedKeys.filter((item) => item !== value)

    setCheckedKeys(nextCheckedKeys)
    setCountSelected(nextCheckedKeys.length)
  }

  const CheckCell = ({ rowData, onChange, checkedKeys, dataKey, ...props }) => {
    // if (!rowData.isEnableEdit) {
    //   return (
    //     <Cell {...props} style={{ padding: 0 }}>
    //       <Checkbox inline disabled style={{ marginLeft: -30 }} />
    //       {props.rowIndex + 1}
    //     </Cell>
    //   )
    // }

    return (
      <Cell {...props} style={{ padding: 0 }}>
        <div style={{ lineHeight: '46px' }}>
          <Checkbox
            value={rowData[dataKey]}
            inline
            onChange={onChange}
            checked={checkedKeys.some((item) => item === rowData[dataKey])}
            style={{ marginLeft: -30 }}
          />
          {props.rowIndex + 1}
        </div>
      </Cell>
    )
  }

  const openFile = (filePath) => {
    const url = filePath
    window.open(url, '_blank')
  }

  return (
    <>
      {isLoading && <OverlayLoader />}
      <Panel collapsible defaultExpanded bordered style={{ marginTop: 20 }}>
        <Row style={{ marginTop: 10 }}>
          {schema.projectCode && (
            <Col lg={12} md={12} sm={12} xs={12}>
              <ControlLabel>
                {requiredFiled(schema.projectCode.validators, schema.projectCode.label)}
              </ControlLabel>
              <Controller
                name={schema.projectCode.name}
                control={control}
                defaultValue={searchProjectCode}
                value={searchProjectCode}
                render={(props) => {
                  return (
                    <Input
                      value={searchProjectCode}
                      placeholder={schema.projectCode.label}
                      onChange={(value) => {
                        props.onChange(value)
                        setSearchProjectCode(value)
                      }}
                    />
                  )
                }}
              />
            </Col>
          )}
          {schema.toProjectCode && (
            <Col lg={12} md={12} sm={12} xs={12}>
              <ControlLabel>
                {requiredFiled(schema.toProjectCode.validators, schema.toProjectCode.label)}
              </ControlLabel>
              <Controller
                name={schema.toProjectCode.name}
                control={control}
                defaultValue={toProjectCode}
                value={toProjectCode}
                render={(props) => {
                  return (
                    <Input
                      value={toProjectCode}
                      placeholder={schema.toProjectCode.label}
                      onChange={(value) => {
                        props.onChange(value)
                        setToProjectCode(value)
                      }}
                    />
                  )
                }}
              />
            </Col>
          )}
        </Row>

        <Row style={{ marginTop: 10, marginLeft: 5 }}>
          <IconButton
            appearance="ghost"
            icon={<Icon icon="search" className="bt-gost-icon-radius" />}
            onClick={() => {
              handleSearchMigrationAsset(searchProjectCode)
              // if(isEmpty(toProjectCode)) {
              //   setToProjectCode(searchProjectCode)
              // }
            }}
            size="sm"
          >
            ค้นหา
          </IconButton>
        </Row>

        <div className="table-all-articles">
          <Table
            wordWrap
            autoHeight
            headerHeight={fs <= 16 ? 40 : 80}
            loading={loading}
            data={tableData}
            style={{ marginTop: '20px' }}
            affixHeader
          >
            <Column width={95} align="center">
              <HeaderCell style={{ padding: 0 }}>
                <div style={{ lineHeight: '40px' }}>
                  <Controller
                    name="chkRow"
                    control={control}
                    render={(props) => {
                      return (
                        <Checkbox
                          inline
                          checked={props.value}
                          indeterminate={indeterminate}
                          onChange={(e, checked) => {
                            props.onChange(checked)
                            handleCheckAll(null, checked)
                          }}
                          style={{ marginLeft: -10 }}
                        >
                          <b>ลำดับ</b>
                        </Checkbox>
                      )
                    }}
                  />
                </div>
              </HeaderCell>

              <CheckCell
                dataKey="assetCode"
                checkedKeys={checkedKeys}
                onChange={(value, checked) => {
                  handleCheck(value, checked)
                }}
              />
            </Column>

            <Column width={140}>
              <HeaderCell>รหัสโครงการ</HeaderCell>
              <Cell dataKey="currentProjectCode" />
            </Column>

            <Column width={180} align="center">
              <HeaderCell>รหัสครุภัณฑ์</HeaderCell>
              {/* <Cell dataKey="assetCode" style={{ fontWeight: 'bold' }} /> */}
              <Cell>
                {(rowData) => {
                  return <b style={{ color: '#2da888' }}>{rowData.assetCode}</b>
                }}
              </Cell>
            </Column>

            <Column width={210} minWidth={210} flexGrow={1}>
              <HeaderCell>ชื่อครุภัณฑ์</HeaderCell>
              <Cell dataKey="durableGoodsName" />
            </Column>

            <Column width={180}>
              <HeaderCell>ประเภทครุภัณฑ์</HeaderCell>
              <Cell dataKey="categoryDesc" />
            </Column>

            <Column width={180}>
              <HeaderCell>SerialNo</HeaderCell>
              <Cell dataKey="serialNo" />
            </Column>

            <Column width={180}>
              <HeaderCell>model</HeaderCell>
              <Cell dataKey="model" />
            </Column>

            <Column width={140}>
              <HeaderCell>วันที่ใบเสร็จ</HeaderCell>
              <Cell dataKey="receiptDate" />
            </Column>

            {/* <Column width={180} align="right">
              <HeaderCell>ราคา/หน่วย</HeaderCell>
              <Cell>
                {(rowData) => {
                  return budgetFormat(rowData.amount || 0)
                }}
              </Cell>
            </Column> */}

            <Column width={180} align="right">
              <HeaderCell>ราคา</HeaderCell>
              <Cell>
                {(rowData) => {
                  return budgetFormat(rowData.amount || 0)
                }}
              </Cell>
            </Column>

            <Column width={180} align="right">
              <HeaderCell>รูปครุภัณฑ์</HeaderCell>
              <Cell>
                {(rowData) => {
                  if (isEmpty(rowData.assetFilePath)) {
                    return
                  }
                  return (
                    <IconButton
                      appearance="ghost"
                      icon={<Icon icon="eye" className="bt-gost-icon-radius" />}
                      size="sm"
                      onClick={(e) => {
                        openFile(rowData.assetFilePath)
                      }}
                    >
                      แสดง
                    </IconButton>
                  )
                }}
              </Cell>
            </Column>

            <Column width={180} align="right">
              <HeaderCell>ใบเสร็จ</HeaderCell>
              <Cell>
                {(rowData) => {
                  if (isEmpty(rowData.receiptFilePath)) {
                    return
                  }
                  return (
                    <IconButton
                      appearance="ghost"
                      icon={<Icon icon="eye" className="bt-gost-icon-radius" />}
                      size="sm"
                      onClick={(e) => {
                        openFile(rowData.receiptFilePath)
                      }}
                    >
                      แสดง
                    </IconButton>
                  )
                }}
              </Cell>
            </Column>

            <Column width={200} fixed="right">
              <HeaderCell>รายการซ้ำ</HeaderCell>
              <Cell>
                {(rowData) => {
                  return (
                    <p style={{ color: rowData.hasAsset ? '#fb8a81' : '' }}>
                      {rowData.hasAsset ? (
                        <>
                          <Icon
                            icon="exclamation-circle2"
                            style={{ color: rowData.hasAsset ? '#fb8a81' : '', marginRight: 5 }}
                          />
                          รายการนี้มีข้อมูลแล้ว
                        </>
                      ) : (
                        ''
                      )}
                    </p>
                  )
                }}
              </Cell>
            </Column>
          </Table>
        </div>
      </Panel>

      <Row style={{ marginTop: 10 }}>
        <Button
          loading={isLoading}
          color="blue"
          appearance="primary"
          onClick={(e) => {
            setIsShowConfirm(true)
          }}
        >
          {`Migrate ครุภัณฑ์ (${countSelected} รายการ)`}
        </Button>
      </Row>

      <ConfirmWidget
        title={`ยืนยันการ Migrate ครุภัณฑ์`}
        show={isShowConfirm}
        detail={
          <>
            <span>ยืนยันการ Migrate ครุภัณฑ์เข้าระบบ e-granting</span>
            <p style={{ color: '#fb8a81' }}>
              หมายเหตุ : รายการครุภัณฑ์ที่มีอยู่แล้วจะถูก update ด้วยข้อมูล migrate
            </p>
          </>
        }
        onCancle={() => setIsShowConfirm(false)}
        onConfirm={() => onSubmit()}
        size="md"
      />
    </>
  )
}
